<style lang="sass">
.page-top
  text-align: center
  background-color: var(--navigation-background-color)
  padding-top: 0 !important
  padding-bottom: 0 !important
.page-bottom
  background: linear-gradient(to bottom, var(--blue) 100px, var(--light-gray) 50.0001px)
</style>
<template>
  <div class="page">
    <div class="padded page-top">
      <span class="font-style-1">
        Reset your password
      </span>
    </div>
    <div class="padded page-bottom">
      <form @submit.prevent="attemptPasswordReset">
        <div v-if="errors.length">
          <div v-for="(error,i) in errors" :key="i">{{error}}</div>
        </div>
        <div class="input-group">
          <label>EMAIL</label>
          <input type="email" placeholder="Email" v-model="passwordReset.email" class="input-control">
        </div>
        <div>
          <input type="submit" value="Reset" class="button positive">
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'PasswordReset',
  created: function() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftImg: 'icon-back.svg', leftRoute: {name: 'login'}, centerEnabled: false});
  },
  data() {
    return {
      success: false,
      errors: [],
      passwordReset: {
        email: this.$route.params.email
      }
    };
  },
  methods: {
    attemptPasswordReset: function() {
      api.PasswordReset.create({params: {reset: this.passwordReset}})
        .then(() => {
          this.$store.dispatch('messages/setMessage', {key: 'loginMessage', message: 'Password reset, check your email'});
          this.$store.dispatch('messages/setMessage', {key: 'loginEmail', message: this.passwordReset.email});
          this.$router.push({name: 'login'});
        }).catch(({response: {data: {errors}}}) => {
          this.success = false;
          this.errors = errors;
        });
    }
  }
};
</script>
